import { selectUser } from '@glass/web/modules/auth';

import consentFormToValues from '@glass/shared/modules/auth/consentFormToValues';
import createUserMutation from '@glass/shared/modules/auth/queries/createUser.graphql';
import signInAuthAction from '@glass/shared/modules/auth/signInAuthAction';

// returns an authenticated user
const createUserAction =
  (authForm) =>
  async (dispatch, getState, { client, tracking }) => {
    const user = selectUser(getState());
    if (user) {
      return user;
    }

    const variables = consentFormToValues(authForm);

    return client
      .mutate({
        mutation: createUserMutation,
        variables,
      })
      .then(({ data }) => {
        tracking.createAuth({
          variables,
        });
        return dispatch(signInAuthAction(data.createUser, { variables }));
      });
  };

export default createUserAction;
